// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".diamond[data-v-4f0a21e9]{border-radius:50%;height:12px;transition:all .3s ease 0s;width:12px}.diamond[data-v-4f0a21e9]:not(.diamond--static):hover{box-shadow:0 0 0 2.5px transparent,0 0 0 3.5px transparent;transform:scale(1.4)}.diamond--active[data-v-4f0a21e9]{box-shadow:0 0 0 2.5px #fff,0 0 0 3.5px #000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
